// extracted by mini-css-extract-plugin
module.exports = {"rgpdContainer":"rgpd-module--rgpd-container--3HA4G","rgpdTitle":"rgpd-module--rgpd-title--3pmKn","rgpdSubTitle":"rgpd-module--rgpd-sub-title--36BIg"};